import { render, staticRenderFns } from "./Printp.vue?vue&type=template&id=61a8dcec&scoped=true&"
import script from "./Printp.vue?vue&type=script&lang=js&"
export * from "./Printp.vue?vue&type=script&lang=js&"
import style0 from "./Printp.vue?vue&type=style&index=0&id=61a8dcec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8dcec",
  null
  
)

export default component.exports